(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/first-page/suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/first-page/suspension.js');
'use strict';

const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  SvsSuspensionNavigate,
  SvsSuspensionLogin,
  ExternalSuspension
} = svs.spelpaus.pages.firstPage.components;
const Suspension = () => {
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  return React.createElement("div", {
    className: "align-center padding-2 line-height-150"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    xs: 12
  }, React.createElement("div", {
    className: "align-center margin-top-3"
  }, React.createElement(Icon, {
    color: "fc-tur",
    icon: "spelpaus",
    size: "1000"
  })))), React.createElement(GridRow, null, React.createElement(GridCol, {
    md: {
      col: 8,
      offset: 2
    },
    xs: 12
  }, React.createElement(GridRow, null, React.createElement(GridCol, {
    md: {
      col: 6
    },
    xs: 12
  }, React.createElement("div", {
    className: "align-center margin-top-4"
  }, isLoggedIn ? React.createElement(SvsSuspensionNavigate, null) : React.createElement(SvsSuspensionLogin, null))), React.createElement(GridCol, {
    md: {
      col: 6
    },
    xs: 12
  }, React.createElement("div", {
    className: "align-center margin-top-4"
  }, React.createElement(ExternalSuspension, null))))))));
};
svs.spelpaus.pages.firstPage.Suspension = Suspension;

 })(window);